import { useMutation } from '@tanstack/react-query';
import { AxiosInstance } from 'axios';
import { useAxiosClientsContextProvider } from 'shared/axios/axios-clients-provider';

import SendTestEventCommand from '../models/send-test-event-command';

const deviceBaseUrl = '/api/v1/Device';

enum SendTestEventQueryPaths {
  SendTestEvent = 'SendTestEvent',
}

const sendTestEvent = async (axiosInstance: AxiosInstance, body: SendTestEventCommand): Promise<void> => {
  await axiosInstance.post(`${deviceBaseUrl}/${SendTestEventQueryPaths.SendTestEvent}`, body);
};

export const usePostTestEvent = () => {
  const { authenticatedInstance } = useAxiosClientsContextProvider();
  return useMutation({
    mutationKey: [SendTestEventQueryPaths.SendTestEvent],
    mutationFn: (body: SendTestEventCommand) => sendTestEvent(authenticatedInstance, body),
  });
};
